import CustomerAPI from 'api/customer';
import events from 'lib/events';
import moment from 'moment';
import PrintableSummary from '../../components/printableSummary';
import PropTypes from 'prop-types';
import React from 'react';
import {dateTimeFormats} from 'helpers/constants';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

const currentYear = new Date().getFullYear();

class SystemSummary extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
    TruBlueActive: PropTypes.bool,
    data: PropTypes.object,
    filters: PropTypes.object,
    showNoDataMessage: PropTypes.bool,
  };

  state = {};

  export = () => {
    const {filters} = this.props;

    CustomerAPI.getAccountSystemListExport(
      this.props.intl.locale,
      filters.dateFrom !== null ? filters.dateFrom : moment().set({'year': 1986, 'month': 0, 'date': 1}).format(dateTimeFormats.numeralDate),
      filters.dateTo !== null ? filters.dateTo : moment().format(dateTimeFormats.numeralDate),
      filters.store,
      filters.systemType,
      filters.groundLevel,
      filters.sanitazer,
      filters.accountStatus
    );
  };

  getDateRange = (labelled = true) => {
    const {formatMessage} = this.props.intl;

    return formatMessage({id: labelled ? 'general.date.range.labelled' : 'general.date.range'}, {
      start: this.props.filters.dateFrom,
      end: this.props.filters.dateTo,
    });
  };

  printReport(data) {
    var summary = data;
    let {formatMessage} = this.props.intl;
    const columns = [
      {name: formatMessage({id: 'general.total.accounts'}), key: 'TotalAccounts'},
      {name: formatMessage({id: 'general.active.accounts'}), key: 'ActiveAccounts'},
      {name: formatMessage({id: 'general.inactive.accounts'}), key: 'InactiveAccounts'},
      {name: formatMessage({id: 'general.total.systems'}), key: 'TotalSystems'},
      {name: formatMessage({id: 'general.total.pools'}), key: 'TotalPools'},
      {name: formatMessage({id: 'general.in.ground.pools'}), key: 'InGroundPools'},
      {name: formatMessage({id: 'general.above.ground.pools'}), key: 'AboveGroundPools'},
      {name: formatMessage({id: 'general.splasher.pools'}), key: 'SplasherPools'},
      {name: formatMessage({id: 'general.swim.spas'}), key: 'SwingSpas'},
      {name: formatMessage({id: 'general.spas'}), key: 'Spas'},
      {name: formatMessage({id: 'general.total.maintenance'}), key: 'TotalSystemsMaintenance'},
    ];

    let trublueColumns = [
      {name: formatMessage({id: 'reports.active.trublue.accounts'}), key: 'ActiveTruBlueSystems'},
      {name: formatMessage({id: 'reports.inactive.trublue.accounts'}), key: 'InactiveTruBlueSystems'},
      {name: formatMessage({id: 'reports.eligible.trublue.accounts'}), key: 'EligibleTruBlueSystems'},
    ];

    if (this.props.TruBlueActive) {
      columns.splice(4, 0, ...trublueColumns);
    }

    return <PrintableSummary
      columns={columns}
      date={this.getDateRange(false)}
      dateLabel={formatMessage({id: 'general.date'})}
      summary={summary}
      title={formatMessage({id: 'reports.customer.all.systems'})}
    />;
  }

  render() {
    let carts;
    let data = this.props.data;
    let {formatMessage} = this.props.intl;


    if (data && Object.keys(data).length) {
      let summary = [
        {title: formatMessage({id: 'general.total.accounts'}), value: data.TotalAccounts ? data.TotalAccounts : 0},
        {title: formatMessage({id: 'general.active.accounts'}), value: data.ActiveAccounts ? data.ActiveAccounts : 0},
        {title: formatMessage({id: 'general.inactive.accounts'}), value: data.InactiveAccounts ? data.InactiveAccounts : 0},
        {title: formatMessage({id: 'general.total.systems'}), value: data.TotalSystems ? data.TotalSystems : 0},
        {title: formatMessage({id: 'general.total.pools'}), value: data.TotalPools ? data.TotalPools : 0},
        {title: formatMessage({id: 'general.in.ground.pools'}), value: data.InGroundPools ? data.InGroundPools : 0},
        {title: formatMessage({id: 'general.above.ground.pools'}), value: data.AboveGroundPools ? data.AboveGroundPools : 0},
        {title: formatMessage({id: 'general.splasher.pools'}), value: data.SplasherPools ? data.SplasherPools : 0},
        {title: formatMessage({id: 'general.swim.spas'}), value: data.SwingSpas ? data.SwingSpas : 0},
        {title: formatMessage({id: 'general.spas'}), value: data.Spas ? data.Spas : 0},
        {title: formatMessage({id: 'general.total.maintenance'}), value: data.TotalSystemsMaintenance ? data.TotalSystemsMaintenance : 0},
      ];

      let trublueColumns = [
        {title: formatMessage({id: 'reports.active.trublue.accounts'}), value: data.ActiveTruBlueSystems ? data.ActiveTruBlueSystems : 0},
        {title: formatMessage({id: 'reports.inactive.trublue.accounts'}), value: data.InactiveTruBlueSystems ? data.InactiveTruBlueSystems : 0},
        {title: formatMessage({id: 'reports.eligible.trublue.accounts'}), value: data.EligibleTruBlueSystems ? data.EligibleTruBlueSystems : 0},
        {title: '\u00A0', value: '\u00A0'},
      ];

      if (this.props.TruBlueActive) {
        summary.splice(4, 0, ...trublueColumns);
      }

      carts = summary.map((cart, i) =>
        <div className='col-sm-3' key={i} >
          {cart.title} <br />
          <span>{cart.value}</span>
        </div>
      );
    }

    return <div>
      <div className='summary-container'>
        <h2><FormattedMessage id='reports.report.summary'/></h2>
        <span className={this.props.filters.dateFrom ? 'summary-date' : 'not-show'}> | <FormattedMessage id='general.date.from'/>: {this.getDateRange()}</span><br/>
        <span><FormattedMessage id='reports.reveal.report.summary'/></span>
        {this.props.showNoDataMessage ?
          <label className='report-no-data'><FormattedMessage id='reports.error.no.results'/></label> : ''}
        <div className='container-fluid'>
          <div className={Object.keys(data).length ? 'row' : 'not-show'}
               id='row-no-padding'>
            {carts}
          </div>
        </div>
      </div>
      <div className='col-sm-12 button-group shift-right'>
        <button className='btn btn-default pull-right'
                disabled={Object.keys(data).length <= 0}
                onClick={() => {
                  events.publish('print', this.printReport(this.props.data));
                }}><FormattedMessage id='reports.print.summary'/></button>
        <button className='btn btn-primary pull-right'
                onClick={this.export}><FormattedMessage id='reports.export.report'/></button>
      </div>
    </div>;
  }
}

export default injectIntl(SystemSummary);
